<template>
    <div>
        <div class="calibration-type">
            {{ calibrationType }}
        </div>
        <div class="calibration-input">
            <ScoreCalibration
                v-if="nBox.calibration_type == 'score'"
                :disabled="!canCalibrate"
                :state="{
                    x: checkState($v.form.x_score),
                    y: checkState($v.form.y_score),
                }"
                :currentScores="{
                    x: user.calibrated.x,
                    y: user.calibrated.y,
                }"
                :newXScore.sync="$v.form.x_score.$model"
                :newYScore.sync="$v.form.y_score.$model"
            />
            <QuadrantCalibration
                v-else
                :user="user"
                :state="formIsValid"
                :disabled="!canCalibrate"
                :quadrants="nBox.quadrants"
                :currentQuadrant="currentQuadrant"
                :newXScore.sync="$v.form.x_score.$model"
                :newYScore.sync="$v.form.y_score.$model"
            />
            <div class="d-flex justify-content-end mb-1 mt-1">
                <ButtonLoader
                    size="sm"
                    variant="primary"
                    :loader="isSubmitting"
                    :disabled="disabledSubmitButton"
                    @click="onSubmit"
                >
                    {{ $t('form.button.calibrate') }}
                </ButtonLoader>
            </div>
        </div>
    </div>
</template>
<script>
import i18n from '@/i18n'
import { validationMixin } from 'vuelidate'
import ButtonLoader from '@/views/components/button-loader'
import { required, decimal, minValue } from 'vuelidate/lib/validators'
import ScoreCalibration from './components/ScoreCalibration'
import QuadrantCalibration from './components/QuadrantCalibration'
export default {
    components: {
        ButtonLoader,
        ScoreCalibration,
        QuadrantCalibration,
    },
    mixins: [validationMixin],
    props: {
        isSubmitting: Boolean,
        nBox: {
            type: Object,
            required: true,
        },
        user: {
            type: Object,
            required: true,
        },
        currentQuadrant: {
            type: Object,
            required: true,
        },
    },
    validations: {
        form: {
            x_score: { required, decimal, minValue: minValue(0) },
            y_score: { required, decimal, minValue: minValue(0) },
        },
    },
    data() {
        return {
            form: {},
        }
    },
    computed: {
        calibrationType() {
            return this.nBox.calibration_type == 'score'
                ? i18n.t('nBox.calibrationByScore')
                : i18n.t('nBox.calibrationByQuadrant')
        },
        disabledSubmitButton() {
            return (
                this.user.$invalid ||
                this.isSubmitting ||
                this.nBox.isLoading ||
                !this.canCalibrate
            )
        },
        canCalibrate() {
            const visualizationType = this.nBox.filters.visualization_type
            return visualizationType == 'calibrated'
        },
        formIsValid() {
            return this.checkState(this.$v.form)
        },
    },
    watch: {
        user() {
            this.resetForm()
        },
    },
    mounted() {
        this.setFormData()
    },
    methods: {
        resetForm() {
            this.setFormData()
            this.$v.$reset()
        },
        setFormData() {
            this.form = {
                n_box_id: this.nBox.id,
                user_id: this.user.id,
                x_score: null,
                y_score: null,
            }
        },
        onSubmit() {
            this.$v.$touch()
            if (!this.formIsValid) {
                return
            }
            this.$emit('submit', this.form)
        },
        checkState(item) {
            return item.$dirty ? !item.$invalid : null
        },
    },
}
</script>
<style lang="scss" scoped>
::v-deep .label {
    font-size: 14px;
    font-weight: 600;
    text-align: center;
}
::v-deep .form-group {
    margin-bottom: 5px;
}

.calibration-type {
    color: #929292;
    font-size: 12px;
    text-transform: uppercase;
}

.calibration-input {
    padding: 5px;
    border-radius: 5px;
    border: 1px solid #e4e7ea;
}
</style>
